export default __webpack_public_path__ + "static/icon-35-3-feeae749afad573365dee810885aa189.png";